<template>
  <div
    :class="[
      'v-searchable-select',
      'v-searchable-select-shallow',
      small && 'v-searchable-select--small',
      gray && 'v-searchable-select--gray',
      search && 'v-searchable-select--search',
      disabled && 'v-searchable-select-shallow--disabled'
    ]"
    v-on="$listeners">
    <div v-if="!async" class="multiselect__caret">
      <v-icon name="caret" width="12" />
    </div>
    <div v-if="search" class="multiselect__search-icon">
      <v-icon name="search" width="22" />
    </div>
    <div class="multiselect__tags">
      <span class="multiselect__placeholder">{{getPlaceholderValue()}}</span>
    </div>
    <input type="hidden" :name="name" :value="getInputValue()" />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [Object, String],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    async: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getPlaceholderValue() {
      if (this.value) {
        return this.value[this.label] || this.value;
      } else {
        return this.placeholder;
      }
    },
    getInputValue() {
      if (this.value) {
        return this.value["value"] || this.value;
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.v-searchable-select-shallow {
  position: relative;
  cursor: pointer;
  width: 100%;

  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .multiselect__placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
